import './App.css';
import Home from './pages/home';
import { Routes, Route } from "react-router-dom";
import About from './pages/about';
import Pricing from './pages/pricing';
import TestLibrary from './pages/test_library';
import Contact from './pages/contact';
import Signup from './pages/signup/';
import CheckoutPage from './pages/checkout';
import Success from './pages/success/index';
import ErrorPage from './pages/error_page';

function App() {

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="plans" element={<Pricing />} />
        <Route path="test-library" element={<TestLibrary />} />
        <Route path="science" element={<About />} />
        <Route path="contact" element={<Contact />} />
        <Route path="checkout" element={<CheckoutPage />} />
        <Route path="free" element={<Signup tier="free" />} />
        <Route path="premium" element={<Signup tier="premium" />} />
        <Route path="standard" element={<Signup tier="standard" />} />
        <Route path="success/:plan" element={<Success />} />
        <Route path="error/:plan" element={<ErrorPage />} />
      </Routes>
    </div>
  );
}

export default App;
